import {ReactNode} from "react";
import {ProviderProps} from "../types/providerProps";
import {AppInitialization} from "@/app/initialization/AppInitialization";
import {NavigationLoader} from "@/shared/ui/NavigationLoader";

type AppProviderProps = {
    providerProps: ProviderProps;
    children: ReactNode;
};

export const AppProviders = ({providerProps, children}: AppProviderProps) => {
    return (
        <>
            <AppInitialization providerProps={providerProps} />
            <NavigationLoader />
            {children}
        </>
    );
};
